import request from '@capturi/request'
import { useOrganization } from '@capturi/stores'
import { Button } from '@capturi/ui-components'
import {
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react'
import { Trans } from '@lingui/macro'
import React, { useState } from 'react'

import { useInput } from '@capturi/react-utils'
import { useAddTextImporter } from '../useTextImporter'
import { type BoostAiAddPayload, type BoostAiAuth, URL_KEY } from './types'

type Props = {
  onClose: () => void
}

const AddBoostAi: React.FC<Props> = ({ onClose }) => {
  const { mutate: addImporter, isPending } =
    useAddTextImporter<BoostAiAddPayload>(URL_KEY)
  const { name } = useOrganization()
  const [state, handleSetState] = useInput<BoostAiAuth>({
    site: '',
    bearerToken: '',
  })
  const [testInProgress, setTestInProgress] = useState(false)
  const [testError, setTestError] = useState('')

  const handleAdd = async (): Promise<void> => {
    setTestInProgress(true)
    setTestError('')

    try {
      await request.post(`importer/${URL_KEY}/test-auth`, {
        json: { auth: state },
      })

      addImporter(
        {
          auth: state,
          friendlyName: `${name} - BoostAi`,
          continuationToken: new Date(),
          customFields: [],
          filters: {},
        },
        {
          onSuccess: () => {
            onClose()
          },
        },
      )
    } catch (_error) {
      setTestInProgress(false)
      setTestError('Invalid authentication')
    }
  }
  const inProgress = isPending || testInProgress
  return (
    <Modal isOpen={true} onClose={onClose} closeOnEsc={!inProgress}>
      <ModalOverlay>
        <ModalContent>
          <Flex direction="column">
            <ModalHeader>BoostAi importer</ModalHeader>
          </Flex>
          {!inProgress && <ModalCloseButton />}
          <ModalBody>
            <Stack spacing={4}>
              <FormControl>
                <FormLabel htmlFor="site">site / subdomain</FormLabel>
                <InputGroup>
                  <InputLeftAddon>https://</InputLeftAddon>
                  <Input
                    isDisabled={isPending}
                    placeholder={'site'}
                    {...handleSetState.site}
                  />
                  <InputRightAddon>.boost.ai</InputRightAddon>
                </InputGroup>
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="bearerToken">Bearer Token</FormLabel>
                <Input
                  isDisabled={isPending}
                  placeholder={'bearerToken'}
                  {...handleSetState.bearerToken}
                />
              </FormControl>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <div>
              <HStack spacing={4}>
                <Button secondary isDisabled={inProgress} onClick={onClose}>
                  <Trans>Cancel</Trans>
                </Button>
                <Button
                  primary
                  isLoading={inProgress}
                  mr={3}
                  onClick={handleAdd}
                >
                  <Trans>Add BoostAi importer</Trans>
                </Button>
              </HStack>
              <Text textAlign="end" color="red">
                {testError}
              </Text>
            </div>
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  )
}

export default AddBoostAi
